import React from "react";
const ManagePage = (props) => {
    return (React.createElement("div", null));
};
export default ManagePage;
